import { Provider } from 'mobx-react';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import App from './Components/App';
import Print from './Components/Print/Print';
import registerServiceWorker from './registerServiceWorker';
import { RootStore } from './Stores/Root/RootStore';



const stores = new RootStore();

class Index extends React.Component {
    public render() {
        // const renderSuspense = <div><img src="/assets/images/brand-logo.png" className="brand-image" /></div>;
        return(
            <BrowserRouter>
                <Provider stores={stores} errors={stores.ErrorsStore}>
                    <Switch>
                        <Route path="/print" component={Print} />
                        <Route path="/" component={App} />
                    </Switch>
                </Provider>
            </BrowserRouter>
        );
    }
}

ReactDOM.render(<Index />,
    document.getElementById('root') as HTMLElement
);
registerServiceWorker();


// WEBPACK FOOTER //
// ./src/index.tsx